package com.merkost.handpass.api.dto.storage

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class UploadUrlRequest(
    val bucket: String,
    @SerialName("content_type") val contentType: String,
    @SerialName("file_size") val fileSize: Long
)
